<template>
  <mdb-container fluid class="justify-content-md-center wrapper">
    <mdb-container class="justify-content-md-center firstrow">
      <mdb-row class="justify-content-md-center secondrow">
        <mdb-col class="bcol" col>
          <router-link to="/estimate/107">
            <mdb-view class="view" hover src="/static/images/cars/crazydeal/crazydeal1.png" alt="">
              <a><h5 class="crazycar">BMW 5 시리즈</h5></a>
              <a class="crazya"><h6 class="blinking">월 약 70만원</h6></a>
              <a class="crazya"><h6 class="blinking">(금리 약 0.5%)</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link to="/estimate/38">
            <mdb-view class="view" hover src="/static/images/cars/crazydeal/crazydeal2.png" alt="">
              <a><h5 class="crazycar">벤츠 E클래스</h5></a>
              <a class="crazya"><h6 class="blinking">월 약 93만원</h6></a>
              <a class="crazya"><h6 class="blinking">(금리 1.1)</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link to="/estimate/73">
            <mdb-view class="view" hover src="/static/images/cars/crazydeal/crazydeal3.png" alt="">
              <a><h5 class="crazycar">벤츠 S클래스</h5></a>
              <a class="crazya"><h6 class="blinking">월 약 175만원</h6></a>
              <a class="crazya"><h6 class="blinking">(금리 약 2.3%)</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
        <mdb-col class="bcol" col>
          <router-link to="/estimate/205">
            <mdb-view class="view" hover src="/static/images/cars/crazydeal/crazydeal4.png" alt="">
              <a><h5 class="crazycar">제네시스 G80</h5></a>
              <a class="crazya"><h6 class="blinking">월 약 59만원</h6></a>
              <a class="crazya"><h6 class="blinking">(금리 약 1.1%)</h6></a>
              <mdb-mask class="overlay" flex-center overlay="stylish-strong" text="최저금리 견적서 확인" />
            </mdb-view>
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </mdb-container>
</template>

<script>
export default {
  name: 'HoverEffect',
};
</script>

<style scoped>
.container-fluid{
    max-width: 100%;
    height: auto;
    padding-left: 0px;
    padding-right: 0px;
    margin-right: 0px;
    margin-left: 0px;
    align-items: center;
    align-content: center;
}
.firstrow {
  margin: 0px 0px !important;
  max-height: 500px !important;
  justify-content: center!important;
  max-width: 100%;
  align-items: center;
  align-content: center;
  margin: auto auto;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: 0px;
  margin-left: 0px;
}

.wrapper {
  background-color: #212121;
  max-width: 1900px;
  max-height: 520px;
  margin: 0px 0px;
  padding: 0px 0px;
  align-content: center;
  align-items: center;
  justify-content: center!important;
}

.secondrow {
  max-width: 1348px;
  max-height: 100%;
  background-color: #d1d1d1 !important;
  align-items: center;
  margin: auto auto;
}

.crazycar {
  text-align: center;
  color: white;
  background-color: black;
  line-height: 100%;
  margin-bottom: 0px;
  padding-top: 0 0px;
}

.col {
  align-items: center;
  max-height: 350px;
  max-width: 337px;
}

.bcol {
  align-items: center;
  max-height: 350px;
  max-width: 337px;
  padding: 0 0px;
}

.crazya {
  color: white !important;
}

.view {
  max-width: 100%;
  max-height: 100%;
  margin-left: 1.5%;
  margin-right: 1.5%;
  margin-top: 3%;
  margin-bottom: 3%;
  align-items: center;
}

.overlay {
  max-width: 100%;
  max-height: 100%;
  padding: 0px 0px;
  max-height: 100%;
}

.blinking{
  animation:blinkingText 2s infinite;
  background-color: black;
  text-align: center;
  font-weight: 900;
  line-height: 100%;
  margin-bottom: 0px;
  padding-top: 0 0px;
}

@keyframes blinkingText{
  30%{ color: #ffba00; }
  40%{ color: #ffba00; }
  50%{ color: #ffba00; }
  60%{ color :#ffba00; }
  70%{ color: #ffba00; }
}
</style>
